export default __webpack_public_path__ + "static/media/content-256x256.796beeb1.png";